import { useTheme } from "@mui/material";
import { ResponsiveChoropleth } from "@nivo/geo";
import { colors } from "../theme";
import { geoFeatures } from "../data/mockGeoFeatures"
import { mockGeographyData as data } from "../data/mockData";

const GeographyChart = ({ isDashboard = false }) => {
  const theme = useTheme();
  const uiColors = colors(theme.palette.mode);

  return (
      <ResponsiveChoropleth
        data={data}
        features={geoFeatures.features}
        theme={{
          axis: {
            domain: {
              line: {
                stroke: uiColors.grey[100]
              },
            },
            legend: {
              text: {
                fill: uiColors.grey[100]
              },
            },
            ticks: {
              line: {
                stroke: uiColors.grey[100],
                strokeWidth: 1
              },
              text: {
                fill: uiColors.grey[100]
              },
            },
          },
          legends: {
            text: {
              fill: uiColors.grey[100]
            },
          },
        }}
        margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
        domain={[ 0, 1000000 ]}
        unknownColor="#666666"
        label="properties.name"
        valueFormat=".2s"
        projectionScale={isDashboard ? 40 : 150}
        projectionTranslation={isDashboard ? [ 0.49, 0.6 ] : [ 0.5, 0.5 ]}
        projectionRotation={[ 0, 0, 0 ]}
        borderWidth={1.5}
        borderColor="#FFFFFF"
        defs={[
          {
            id: 'dots',
            background: 'inherit',
            color: '#38bcb2',
            size: 4,
            padding: 1,
            stagger: true
          },
          {
            id: 'lines',
            background: 'inherit',
            color: '#eed312',
            rotation: -45,
            lineWidth: 6,
            spacing: 10
          },
          {
            id: 'gradient',
            type: 'linearGradient',
            colors: [
              {
                offset: 0,
                color: '#000'
              },
              {
                offset: 100,
                color: 'inherit'
              }
            ]
          }
        ]}
        fill={[
          {
            match: {
                id: 'CAN'
            },
            id: 'dots'
          },
          {
            match: {
                id: 'CHN'
            },
            id: 'lines'
          },
          {
            match: {
                id: 'ATA'
            },
            id: 'gradient'
          }
        ]}
        legends={
          
          !isDashboard ?
          [{
            anchor: 'bottom-left',
            direction: 'column',
            justify: true,
            translateX: 20,
            translateY: -100,
            itemsSpacing: 0,
            itemWidth: 94,
            itemHeight: 18,
            itemDirection: 'left-to-right',
            itemTextColor: uiColors.grey[100],
            itemOpacity: 0.85,
            symbolSize: 18,
            effects: [
              {
                on: 'hover',
                style: {
                  itemTextColor: '#FFFFFF',
                  itemOpacity: 1
                }
              }
            ]
          }] 
          : undefined
        }
      />
    );
  };
  
  export default GeographyChart;